import { render } from "./all-finalisasi.vue?vue&type=template&id=7ffa302b"
import script from "./all-finalisasi.vue?vue&type=script&lang=js"
export * from "./all-finalisasi.vue?vue&type=script&lang=js"

import "./all-finalisasi.vue?vue&type=style&index=0&id=7ffa302b&lang=css"

import exportComponent from "/home/alfahuma/manual_build/digita-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__